class StickyProVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onStickyVariantChange);
  }

  onStickyVariantChange() {
    this.varOptions = this.querySelector("select");
    //console.log("connected", this.varOptions.value);

    let productForms = document.querySelector(
      `#product-sticky-form-${this.dataset.section}`
    );
    let input = productForms.querySelector('input[name="id"]');
    input.value = this.varOptions.value;
  }
}
customElements.define("sticky-variant-select", StickyProVariantSelect);

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    stickyScroll();
  });
  document.addEventListener("shopify:section:select", (event) => {
     stickyScroll();
  });
  document.addEventListener("shopify:section:deselect", (event) => {
     stickyScroll();
  });
}

let nsmStickyCleanup;
const stickyScroll = () => {
  if (nsmStickyCleanup) nsmStickyCleanup();
  let stickySelectedVariant = document.querySelector(`#sticky__variant`);
  if (stickySelectedVariant) {
    let stickySelectVairantInput = document.querySelector(
      "#sticky__selected_variant_id"
    );
    stickySelectVairantInput.value = stickySelectedVariant.value;
  }
  
  const BuyButtonForm = document.querySelector(".product_buy_button_form");
  const productStickyWrapper = document.querySelector(".product__sticky");
  
  if (!BuyButtonForm || !productStickyWrapper) return;
  let buyTop = 0;
  let scheduled = false;
  let active = productStickyWrapper.classList.contains('sticky');
  const update = () => {
    scheduled = false;
    const next = window.scrollY > buyTop;
    if (next === active) return;
    active = next;
    productStickyWrapper.classList.toggle('sticky', active);
    document.body.classList.toggle('sticky__cart', active);
  };
  const measure = () => {
    buyTop = BuyButtonForm.getBoundingClientRect().top + window.scrollY;
    update();
  };
  const onScroll = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  // Position changes with image/font/variant layout, not with each scroll.
  const observer = new ResizeObserver(measure);
  const productSection = BuyButtonForm.closest('[data-section-type="main-product"]');
  if (productSection) observer.observe(productSection);
  observer.observe(BuyButtonForm);
  const header = document.querySelector('header');
  if (header) observer.observe(header);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measure, { passive: true });
  measure();
  nsmStickyCleanup = () => {
    observer.disconnect();
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', measure);
  };
}
stickyScroll();




